const themeName = process.env.VUE_APP_THEME_NAME

export default [
  {
    path: '/:lang/login',
    name: 'login',
    component: () => import(`@/views/${themeName}/auth/Login.vue`),
    meta: {
      layout: 'full',
      middleware: 'guest',
      route: 'authentication',
    },
  },
  {
    path: 'login-section2',
    name: 'login-section2',
    component: () => import(`@/views/${themeName}/auth/LoginSection2.vue`),
    meta: {
      layout: 'full',
      middleware: 'guest',
      route: 'authentication',
    },
  },
  {
    path: '/:lang/register',
    name: 'register',
    component: () => import(`@/views/${themeName}/auth/Register.vue`),
    meta: {
      layout: 'full',
      middleware: 'guest',
      route: 'authentication',
    },
  },
  {
    path: 'forgot-password',
    name: 'forgot-password',
    component: () => import(`@/views/${themeName}/auth/ForgotPassword.vue`),
    meta: {
      layout: 'full',
      resource: 'Auth',
      middleware: 'guest',
      route: 'authentication',
    },
  },
  {
    path: 'reset-password',
    name: 'reset-password',
    component: () => import(`@/views/${themeName}/auth/ResetPassword.vue`),
    meta: {
      layout: 'full',
      middleware: 'guest',
      route: 'authentication',
    },
  },
  {
    path: 'email-activation',
    name: 'email-activation',
    component: () => import(`@/views/${themeName}/error/EmailActivation.vue`),
    meta: {
      middleware: 'guest',
      layout: 'full',
    },
  },
  {
    path: 'register-success',
    name: 'register-success',
    component: () => import(`@/views/${themeName}/auth/RegisterSuccess.vue`),
    meta: {
      middleware: 'both',
      layout: 'full',
    },
  },
  {
    path: 'agreement-register',
    name: 'agreement-register',
    component: () => import(`@/views/${themeName}/auth/AgreementRegister.vue`),
    meta: {
      middleware: 'both',
      layout: 'full',
    },
  },
  {
    path: 'activation-success',
    name: 'activation-success',
    component: () => import(`@/views/${themeName}/auth/ActivationSuccess.vue`),
    meta: {
      middleware: 'both',
      layout: 'full',
    },
  },
]
